<template>
<b-container fluid v-if="!!loaded">
  <h2>Editing Order #{{num}}</h2>
  <b-form-row>
    <b-col cols=*>
      <b-button class='my-1' variant=info :to="{ name: 'View Order', params: { id: num }}">Back To Order</b-button>
    </b-col>
    <b-col>
      <b-alert show variant=danger class=text-center v-if="!editable">
        This order is not currently editable through Info!
      </b-alert>
    </b-col>
    <b-col cols=*>
      <b-btn class='my-1' variant=success :disabled="!onWebsite && (!override && this.errors.length > 0)" @click="saveToWeb">Save to Web</b-btn>
    </b-col>
  </b-form-row>
  <customer-editor class='mb-3' :num=num :disabled="!onWebsite" :order=order />

  <b-alert :show=toBeImported variant=info>
    This order will be imported to Fishbowl
  </b-alert>
  <b-alert :show=toBeIssued variant=warning>
    This order will be issued on import
  </b-alert>

  <b-alert v-if="inFishbowl && inProgress" show variant=danger class=mx-auto>
    You can't delete or update in-process orders in Fishbowl. Talk to Ops if you can't make the changes you need here.
  </b-alert>
  <b-btn-toolbar justify class=mb-3 v-else>
    <b-button-group v-b-popover.hover=lockedMessage>
      <b-btn variant=dark :disabled=!canDelete :title=deleteTitle @click=deleteAndUnlock>
        Delete FB to Edit More
      </b-btn>
    </b-button-group>
    <b-btn variant=warning :disabled=canReimport :title=deleteTitle @click="saveWorkareaOrder('Save WA and Re-Import FB', importOrder=true, issueOrder=false)">
      Save WA and Re-Import FB
    </b-btn>
    <b-btn variant=success :disabled=canReimport :title=deleteTitle @click="saveWorkareaOrder('Save WA and Re-Import FB', importOrder=true, issueOrder=true)">
      Save WA and Re-Import FB
    </b-btn>
  </b-btn-toolbar>

  <shipping-editor class='mb-3' :num=num :disabled="!onWebsite" :order=order />
  <billing-editor class='mb-3' :num=num :disabled="!onWebsite" :order=order />
  <items-editor class='mb-3' :num=num :disabled="!onWebsite" :order=order />
</b-container>
</template>

<script>
import axios from 'axios'
import InputMerger from '../../utility/InputMerger'
import CustomerEditor from './CustomerEditor'
import ShippingEditor from './ShippingEditor'
import BillingEditor from './BillingEditor'
import ItemsEditor from './ItemsEditor'
const BASE_API = process.env.VUE_API_ROOT

export default {
  data() {
    return {
      num: this.$route.params.id,
      override: false,
      loaded: false,
      order: undefined,
    };
  },
  components: {
    InputMerger,
    CustomerEditor,
    ShippingEditor,
    BillingEditor,
    ItemsEditor,
  },
  mounted() {
    axios.get(`${BASE_API}/bridge/${this.$route.params.id}`).then(response => {
      this.order = response.data.merged;
      this.websiteOrder = response.data.web;
      this.fishbowlOrder = response.data.fishbowl;
    }).finally(() => this.loaded = true);
  },
  computed: {
    editable() {
      return false
    },
    onWebsite() {
      return !!this.order.websiteName && this.order.num[0] !== 'R'
    },
  },
  methods: {
    saveToWeb() {

    },
  },
}
</script>

<style scoped>
.sideTitle {
  border: thin solid black;
  border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/sales-order/edit-order-2/EditOrder.vue